import { DeletableItem } from 'taboola-ultimate-ui';
import { MarketplaceAudiencesTargetingDelimiterTextContent } from './MarketplaceAudiencesTargetingDelimiterTextContent';

export const MarketplaceAudiencesTargetingDelimiter = ({ onDelete }) => (
    <DeletableItem onDelete={onDelete} buttonProps={{ 'data-testid': 'marketplace-audience-targeting-delete-button' }}>
        <MarketplaceAudiencesTargetingDelimiterTextContent />
    </DeletableItem>
);
